import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import { showToast } from "../../../helpers/ToastifyHelper";
import SearchComponent from "../../../components/OB/SearchComponent";
import Select from '@mui/material/Select';
import { FormControl, InputLabel, MenuItem, CircularProgress } from "@mui/material";
import { Form, Formik } from "formik";
import "./IlanReklamVergisiTarifeleri.css" //Cevre Temizlik Css
import IrvTarifeListeAPI from "../../../apis/OB/Get/IrvTarifeListeAPI";
import TableComponent1 from "../../../components/OB/TableComponent1";
import IlanReklamTarifeGetAPI from "../../../apis/OB/Get/IlanReklamTarifeGetAPI";
import IlanReklamVergisiTarifeleriPopup from "../../../components/OB/popups/IlanReklamTarifeleriPopUp";
const IlanReklamVergisiTarifeleri: React.FC = () => {

    const columns = [
        { header: "", field: "", className: "text-center", isPopup: true },
        { header: "Yılı", field: "yili", className: "text-center" },
        { header: "Gelir Kodu", field: "gelirKodu", className: "text-center" },
        { header: "Gelir Alt Kodu", field: "gelirAltKodu", className: "text-center" },
        { header: "Açıklama", field: "aciklama", className: "text-center" },
    ];
    const [data, setData] = useState<any[]>([]);
    const [tarifeGetData, setTarifeGetData] = useState<any[]>([]);
    const [searchControl, setSearchControl] = useState<boolean>(true);
    const { yilListe } = useContext(ConstantAPISContext);
    const [selectedYear, setSelectedYear] = useState(Number(new Date().getFullYear()));
    //Pop-Up
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isLoading, setisLoading] = useState<boolean>(false);
    const openPopup = () => {
        isPopupVisible == true ?
            setIsPopupVisible(false) :
            setIsPopupVisible(true);
    };

    //Cevre Temizlik Tarife API
    useEffect(() => {
        fetchData(false);
    }, [])

    const fetchData = async (isPass: boolean = true) => {
        if (selectedYear !== 0) {
            setisLoading(true);
            const response = await IrvTarifeListeAPI.getIrvTarife(
                selectedYear
            );
            setData(response.data);
            setTimeout(() => {
                setisLoading(false);

            }, 100)
            setSearchControl(true)


        }
        else {
            setSearchControl(false)
            showToast("Lütfen Yılı Seçiniz", "error");
        }
    }
    //Cevre Temizlik Tarife Get API
    const fetchCevreTemizlikGetData = async (yili: number, isPass?: boolean, gelirKodu?: number, gelirAltKodu?: number) => {
        if (yili !== 0) {
            const response = await IlanReklamTarifeGetAPI.getIlanReklamTarifeGet(
                yili,
                gelirKodu,
                gelirAltKodu
            );
            setTarifeGetData(response.data);
            setSearchControl(true)
            if (response.data.length < 1)
                showToast("Kayıt Bulunamadı!", "warning");
            else {
                openPopup();
            }
            //Popup aç


        }
        else {
            setSearchControl(false)
            showToast("Yıl değeri alınamadı", "error");
        }
    }

    const handleTemizle = () => {
        setSelectedYear(Number(new Date().getFullYear()));

    }

    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
        <div className="px-1 px-md-2 px-lg-4 py-3 card   w-100">
            <div className="card-body p-0">
                <Formik
                    initialValues={initialValues}
                    onSubmit={() => { }}>
                    <Form id="kayit-form" className="d-flex w-100 mb-4">
                        <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                            <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <InputLabel id="">Yıl</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        name="yil"
                                        label="yil"
                                        error={selectedYear == undefined && searchControl == false ? true : false}

                                        value={selectedYear || ""}
                                        onChange={(e) => {
                                            setSelectedYear(Number(e.target.value || undefined));
                                        }}                                >
                                        {yilListe.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item.yili}                                            >
                                                {item.yili}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="d-flex  flex-row ms-auto ">
                                <SearchComponent
                                    fetchData={fetchData}
                                    onTemizle={handleTemizle}
                                    setData={setData} />
                            </div>

                        </div>
                    </Form>
                </Formik>
                {isLoading ?
                    <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

                        <CircularProgress />
                    </div>
                    :
                    <TableComponent1 fetchCevreVeyaEglenceGetData={fetchCevreTemizlikGetData} columns={columns} data={data} recordsPerPage={12}></TableComponent1>
                }
                {isPopupVisible && (
                    <div style={{ height: "100vh", position: "absolute", width: "100%", padding: "20px", backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: "1000" }}>
                        <IlanReklamVergisiTarifeleriPopup
                            openPopup={openPopup}
                            data={tarifeGetData}
                        />
                    </div>
                )}
            </div>

        </div >
    )
}

export default IlanReklamVergisiTarifeleri;